const getRolList = (listToTransform) => {
    const data = Object.values(listToTransform);
    const roleList = data.map((item) => {
        if (item.name === "query_system_admin") {
            return {...item, name: "Administrador"};
        } else if (item.name === "query_system_user") {
            return {...item, name: "invitado"};
        }
        return item;
    });
    return roleList;
}
export default getRolList;